import { RouteInfo } from "@tr/models"

// Profile Menu Items
export const clientProfileLinks: RouteInfo[] = [
]

// Menu Items
export const clientLinks: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "ti-dashboard",
    hasDivider: true,
  },
  {
    path: "/results",
    title: "Results",
    icon: "mdi mdi-chart-areaspline",
    hasDivider: false,
  },
  // {
  //   path: "/runs",
  //   title: "New Run",
  //   icon: "mdi mdi-animation-play",
  //   hasDivider: false,
  // },
  {
    path: "/plans",
    title: "Plans",
    icon: "mdi mdi-clock-fast",
    hasDivider: true,
  },
  {
    path: "/tests",
    title: "Test Cases",
    icon: "mdi mdi-view-list",
    hasDivider: false,
  },
  {
    path: "/test-coverage",
    title: "Test Coverage",
    icon: "mdi mdi-map-search",
    hasDivider: true,
  },

  // TODO: monitoring and performance will be added after MVP, including user flows, heat maps, anomaly tracking, performance metrics and anomalies, etc. 
  // {
  //   path: "/monitoring",
  //   title: "Monitoring",
  //   icon: "mdi mdi-comment-eye-outline",
  //   hasDivider: false,
  // },
  // {
  //   path: "/performance",
  //   title: "Performance",
  //   icon: "mdi mdi-chart-multiline",
  //   hasDivider: true,
  // },
  {
    path: "/bugs",
    title: "Bugs",
    icon: "mdi mdi-bug-outline",
    hasDivider: true,
  },
  {
    path: "/run-config",
    title: "Run Configuration",
    icon: "mdi mdi-update",
    hasDivider: false,
  },
  {
    path: "/settings",
    title: "Settings",
    icon: "mdi mdi-settings",
    hasDivider: false,
  }
  // {
  //   path: "",
  //   title: "Settings",
  //   icon: "ti-panel",
  //   children: [
  //     { path: "/environments", title: "Environments", icon: "ti-map" },
  //     { path: "/projects", title: "Projects", icon: "ti-bag" },
  //     { path: "/settings", title: "Settings", icon: "ti-settings" },
  //   ],
  // },
]
